import { z } from 'zod';

export const permissionsSchema = z.array(z.string());
export const roleSchema = z.object({
  id: z.number(),
  name: z.string(),
  permissions: permissionsSchema,
});

export const roleHelper = 'Role is a required. Please select at least one role';
export const rolesSchema = z.array(roleSchema).min(1, roleHelper);
export const rolesOptionalSchema = z.array(roleSchema).optional();

export const nameHelper =
  'Role name is case insensitive. It must have at least 5 characters, one letter, and no spaces. It does not contain special characters';
export const nameSchema = z
  .string()
  .min(5, { message: 'Role name is required. Must be at least 5 characters' })
  .regex(/^\S*$/, {
    message: 'Role name must not have spaces',
  })
  .regex(/^[A-Za-z0-9_]+$/, {
    message: 'Username Does not contain special characters',
  })
  .regex(/[a-zA-Z]/, {
    message: 'Role name must contain at least one letter',
  });
